<script setup lang="ts">
const route = useRoute()

const isListDetail = computed(() => /^\/lists\/(?!create(?:\/|$))[^/]+\/?$/.test(route.path))

const links = [
    { to: '/home', label: 'Utama', icon: 'home' },
    { to: '/lists', label: 'Senarai', icon: 'list' },
    { to: '/history', label: 'Sejarah', icon: 'history' },
    { to: '/dashboard', label: 'Statistik', icon: 'chart' },
] as const

function isActive(to: string): boolean {
    if (to === '/lists') {
        return route.path === '/lists' || isListDetail.value
    }

    return route.path === to || route.path.startsWith(`${to}/`)
}

async function handleNewAction(): Promise<void> {
    if (isListDetail.value) {
        window.dispatchEvent(new CustomEvent('groceries:add-list-item'))

        return
    }

    await navigateTo('/lists/create')
}
</script>

<template>
    <nav
        class="nav-in fixed inset-x-3 bottom-3 z-30 mx-auto grid max-w-[420px] grid-cols-5 gap-1 rounded-3xl p-1.5 md:hidden"
        :style="{
            background: 'color-mix(in srgb, var(--panel), transparent 4%)',
            border: '1px solid var(--line)',
            boxShadow: 'var(--shadow-soft)',
            backdropFilter: 'blur(16px)',
            marginBottom: 'env(safe-area-inset-bottom)',
        }"
        aria-label="Navigasi mudah alih"
    >
        <NuxtLink
            :to="links[0].to"
            class="flex flex-col items-center justify-center gap-0.5 rounded-[18px] py-2 text-[10px] font-medium transition-colors"
            :style="{
                minHeight: '52px',
                background: isActive(links[0].to) ? 'var(--brand)' : 'transparent',
                color: isActive(links[0].to) ? 'var(--panel)' : 'var(--muted)',
            }"
            :aria-current="route.path === links[0].to ? 'page' : undefined"
        >
            <span aria-hidden="true" class="text-lg">
                <AppIcon :name="links[0].icon" class="size-[18px]" />
            </span>
            {{ links[0].label }}
        </NuxtLink>

        <NuxtLink
            :to="links[1].to"
            class="flex flex-col items-center justify-center gap-0.5 rounded-[18px] py-2 text-[10px] font-medium transition-colors"
            :style="{
                minHeight: '52px',
                background: isActive(links[1].to) ? 'var(--brand)' : 'transparent',
                color: isActive(links[1].to) ? 'var(--panel)' : 'var(--muted)',
            }"
            :aria-current="route.path === links[1].to ? 'page' : undefined"
        >
            <span aria-hidden="true" class="text-lg">
                <AppIcon :name="links[1].icon" class="size-[18px]" />
            </span>
            {{ links[1].label }}
        </NuxtLink>

        <button
            type="button"
            class="flex flex-col items-center justify-center gap-0.5 rounded-[18px] py-2 text-[10px] font-medium transition-colors"
            :style="{
                minHeight: '52px',
                background: route.path === '/lists/create' ? 'var(--brand)' : 'transparent',
                color: route.path === '/lists/create' ? 'var(--panel)' : 'var(--muted)',
            }"
            :aria-label="
                isListDetail ? 'Tambah item baharu dalam senarai ini' : 'Buat senarai baharu'
            "
            @click="handleNewAction"
        >
            <span aria-hidden="true" class="text-lg">
                <AppIcon name="plus" class="size-[18px]" />
            </span>
            Baru
        </button>

        <NuxtLink
            :to="links[2].to"
            class="flex flex-col items-center justify-center gap-0.5 rounded-[18px] py-2 text-[10px] font-medium transition-colors"
            :style="{
                minHeight: '52px',
                background: isActive(links[2].to) ? 'var(--brand)' : 'transparent',
                color: isActive(links[2].to) ? 'var(--panel)' : 'var(--muted)',
            }"
            :aria-current="route.path === links[2].to ? 'page' : undefined"
        >
            <span aria-hidden="true" class="text-lg">
                <AppIcon :name="links[2].icon" class="size-[18px]" />
            </span>
            {{ links[2].label }}
        </NuxtLink>

        <NuxtLink
            :to="links[3].to"
            class="flex flex-col items-center justify-center gap-0.5 rounded-[18px] py-2 text-[10px] font-medium transition-colors"
            :style="{
                minHeight: '52px',
                background: isActive(links[3].to) ? 'var(--brand)' : 'transparent',
                color: isActive(links[3].to) ? 'var(--panel)' : 'var(--muted)',
            }"
            :aria-current="route.path === links[3].to ? 'page' : undefined"
        >
            <span aria-hidden="true" class="text-lg">
                <AppIcon :name="links[3].icon" class="size-[18px]" />
            </span>
            {{ links[3].label }}
        </NuxtLink>
    </nav>
</template>
